import type { ReactNode } from "react";
import Card from "../basic/Card";
import { vstack } from "../../../../styled-system/patterns";
import { VStack, Wrap } from "../../../../styled-system/jsx";

interface Props {
  title?: ReactNode;
  byline?: ReactNode;
  status?: ReactNode;

  children?: ReactNode;
}

const SummaryCard = ({ title, byline, status, children }: Props) => {
  const titleIsText = typeof title === "string";
  return (
    <Card
      className={vstack({
        alignItems: "stretch",
      })}
      padding="large"
    >
      <Wrap justifyContent={"space-between"} alignItems={"start"}>
        <VStack gap="xsmall" alignItems={"start"}>
          {titleIsText ?
            <h3
              style={{
                margin: 0,
                lineHeight: "1",
              }}
            >
              {title}
            </h3>
          : title}
          {byline && <small>{byline}</small>}
        </VStack>
        {status}
      </Wrap>

      {children}
    </Card>
  );
};

export default SummaryCard;
